import { uniqueKey } from 'global/common/keys'
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext'
import { gameScoringTypes } from 'projectSpecific/sports/cnr/reducers/SportsSeasonReducer'
import React, { useContext, useMemo } from 'react'
import { Icon, Label } from 'semantic-ui-react'

const _tris = {
  l: 'l',
  mr: 'mr',
  n: 'n',
  nsl: 'nsl',
  nst: 'nst',
  nsw: 'nsw',
  op: 'op',
  p: 'p',
  sl: 'sl',
  smr: 'smr',
  sp: 'sp',
  st: 'st',
  sw: 'sw',
  t: 't',
  w: 'w',
}

export const _teamNames = ['Catholic', 'Christian', 'Academy', 'County']
export const _teamNamesReplace = ['Cath.', 'Christ.', 'Acad.', 'Co.']

export const TeamSectionRecord = ({
  team,
  team_favs,
  rowKey,
  isNonSection,
  tableType,
  valueW,
  forPlayoff,
  handleTeamClick
}) => {

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { currentSeason_info, sportsSeason_info, sportSettings_info } = sportsSeason_state ?? {}
  const { showRankingsInStandings } = sportSettings_info ?? {}
  const { showMatchesRemainingCount } = sportsSeason_info ?? {}
  const { gameScoringType, gameAllowTies, _sportsModeSport } = currentSeason_info ?? {}

  let cellCount = 0

  const label_currentRank = (currentRank) => <Label size={'mini'} className={'team-rank'} circular>{currentRank}</Label>
  const label_section = (sectionRank) => <Label size='mini'>{sectionRank}</Label>
  const label_matchesRemaining = (smr, mr) => <Label size='mini' className='sssmr' title={'Remaining (section:all)'}>
    <Icon name='caret right' />{smr}{':'}{mr}
  </Label>

  const icon_fav = () => <Icon className={'ssfav'} name={'star'} color={'blue'} size={'tiny'} />

  const recordDiv = (t, value, width) => {
    cellCount++
    return <div className={`trr-${t}`} key={uniqueKey('ss', 'rc', cellCount)} >{value}</div>
  }

  const teamRecordDiv = (record) => {

    let trs = []

    const cells = []

    switch (gameScoringType) {
      case gameScoringTypes.match:
      case gameScoringTypes.matchPoints:
      case gameScoringTypes.inning:
        if (record) {
          if (isNonSection) {
            trs = [_tris.sw, _tris.sl]
          } else {
            if (tableType === 'normal') {
              trs = [_tris.nsw, _tris.nsl]
            } else {
              trs = [_tris.sw, _tris.sl]
            }
            if (gameScoringType === gameScoringTypes.matchPoints) {
              trs.push(_tris.p)
            }
            trs.push(_tris.w)
            trs.push(_tris.l)
            if (gameScoringType === gameScoringTypes.matchPoints) {
              trs.push(_tris.op)
            }
          }
        } else {
          trs = [_tris.n, _tris.n]
          if (!isNonSection) {
            if (tableType === 'normal') {
              trs.push(_tris.n)
              trs.push(_tris.n)
            } else {
              trs.push(_tris.n)
              trs.push(_tris.n)
            }
          }
        }
        break;

      case gameScoringTypes.half:
        if (record) {
          if (isNonSection) {
            trs = [_tris.sw, _tris.sl, _tris.st]
          } else {
            if (tableType === 'normal') {
              trs = [_tris.nsw, _tris.nsl, _tris.nst, _tris.nsp]
            } else {
              trs = [_tris.sw, _tris.sl, _tris.st, _tris.sp]
            }
            trs.push(_tris.w)
            trs.push(_tris.l)
            trs.push(_tris.t)
            trs.push(_tris.op)
          }
        } else {
          trs = [_tris.n, _tris.n]
          if (!isNonSection) {
            if (tableType === 'normal') {
              trs.push(_tris.n)
              trs.push(_tris.n)
              trs.push(_tris.n)
              trs.push(_tris.n)
            } else {
              trs.push(_tris.n)
              trs.push(_tris.n)
              trs.push(_tris.n)
              trs.push(_tris.n)
            }
          }
        }
        break;

      case gameScoringTypes.quarter:
        if (record) {
          if (isNonSection) {
            trs = [_tris.sw, _tris.sl, _tris.st]
          } else {
            if (tableType === 'normal') {
              trs = [_tris.nsw, _tris.nsl, _tris.nst]
            } else {
              if (gameAllowTies) {
                trs = [_tris.sw, _tris.sl, _tris.st]
              } else {
                trs = [_tris.sw, _tris.sl]
              }
            }
            trs.push(_tris.w)
            trs.push(_tris.l)
            gameAllowTies && trs.push(_tris.t)
          }
        } else {
          trs = [_tris.n, _tris.n]
          if (!isNonSection) {
            if (tableType === 'normal') {
              trs.push(_tris.n)
              trs.push(_tris.n)
              gameAllowTies && trs.push(_tris.n)
            } else {
              trs.push(_tris.n)
              trs.push(_tris.n)
              gameAllowTies && trs.push(_tris.n)
            }
          }
        }
        break;

      default:
        if (record) {
          if (isNonSection) {
            trs = [_tris.sw, _tris.sl, _tris.st]
          } else {
            if (tableType === 'normal') {
              trs = [_tris.nsw, _tris.nsl, _tris.nst, _tris.nsp]
            } else {
              trs = [_tris.sw, _tris.sl, _tris.st, _tris.sp]
            }
            trs.push(_tris.w)
            trs.push(_tris.l)
            trs.push(_tris.t)
            trs.push(_tris.op)
          }
        } else {
          trs = [_tris.n, _tris.n]
          if (!isNonSection) {
            if (tableType === 'normal') {
              trs.push(_tris.n)
              trs.push(_tris.n)
              trs.push(_tris.n)
            } else {
              trs.push(_tris.n)
              trs.push(_tris.n)
              trs.push(_tris.n)
            }
          }
        }
        break;
    }

    trs.forEach(t => {
      switch (t) {
        case _tris.n:
          cells.push(recordDiv(t, 0, valueW))
          break;
        default:
          cells.push(recordDiv(t, record[t], valueW))
      }

    })

    return cells
  }

  const standingsTeamRow = useMemo(() => {

    const { name, record, _itemKey, currentRank, teamNumber } = team ?? {}

    const { playoffTeam, nonPlayoffTeam, playoffEliminated, playoffAssured, sectionRank, smr, mr, tmm } = record ?? {}

    const playoffTeamCompare = false // playoffTeamCompares && team ? _.find(playoffTeamCompares, { id: team._itemKey }) : null

    const _name = teamName(name)
    // const _firstCn = _name.length > 14 ? firstCn + ' nmr' : firstCn

    const isFav = team_favs && team_favs[_itemKey] ? true : false
    let _rowCn = 'standing-team smr'
    _rowCn += isFav ? ' fav' : ''
    _rowCn += gameScoringType === gameScoringTypes.matchPoints ? ' pts' : ''
    // _rowCn += ' ' + rowCn

    if (playoffTeamCompare) { _rowCn += ' ptc' }

    if (isNonSection && 1 === 3) {
      return <div key={uniqueKey('ss', 'sr', rowKey)} className={_rowCn}>
        <div>{index + 1}</div>
        <div>{'#' + teamNumber}</div>
        <div>{_name}</div>
      </div>
    } else {

      // adjust the class for the row
      if (playoffTeam) { _rowCn += ' ss-pt' }
      if (nonPlayoffTeam) { _rowCn += ' ss-npt' }
      if (playoffEliminated) { _rowCn += ' ss-npte' }
      if (playoffAssured) { _rowCn += ' ss-npta' }
      if (tmm && tmm > 0) { _rowCn += ' ss-mm' }

      return <div key={uniqueKey('ss', 'sr', rowKey)} className={_rowCn} onClick={(e) => handleTeamClick(e, team)}>
        <div className={`trr-team`}>
          <Label size='mini'>{sectionRank}</Label>
          {_name}
          {isFav && icon_fav()}
          {showRankingsInStandings && currentRank && label_currentRank(currentRank)}
          {!forPlayoff && (mr > 0) && showMatchesRemainingCount > smr && label_matchesRemaining(smr, mr)}
          {forPlayoff && label_section(sectionRank)}
        </div>
        {teamRecordDiv(record)}
      </div>
    }
  }, [])

  return standingsTeamRow

}

const teamName = (name) => {
  let _name = name
  for (let i = 0; i < _teamNames.length; i++) {
    if (name.includes(_teamNames[i])) {
      _name = name.replace(_teamNames[i], _teamNamesReplace[i]);
    }
  }
  return _name
}
